import { formatDuration } from '../../engine';
import type { Snapshot } from '../../game/store';

interface TalesPanelProps {
  snapshot: Snapshot;
}

export function TalesPanel({ snapshot }: TalesPanelProps) {
  const { state } = snapshot;

  return (
    <section className="panel">
      <h2 className="panel-title">
        Tales
        <span className="hint">{state.stats.totalTalesSeen} told</span>
      </h2>

      {state.tales.length === 0 ? (
        <p className="empty-note">Nothing worth telling has happened yet.</p>
      ) : (
        state.tales.slice(0, 25).map((tale, index) => (
          <article key={`${tale.id}-${tale.at}-${index}`} className="tale">
            <div className={`tale-title ${tale.favourable ? 'favourable' : 'grim'}`}>
              {tale.title}
            </div>
            <p className="tale-text">{tale.text}</p>
            <div className="tale-meta">
              Generation {tale.generation} · {formatDuration(tale.at)}
              {tale.summary ? ` · ${tale.summary}` : ''}
            </div>
          </article>
        ))
      )}
    </section>
  );
}
